import React from 'react';
import PropTypes from 'prop-types';
import { ContentHeader } from '../../atoms';

const TablePageLayout = ({
  title,
  description,
  primaryAction,
  onPrimaryAction,
  children,
  cardClassName = ''
}) => {
  return (
    <div className="bg-transparent min-h-full">
      <ContentHeader
        title={title}
        description={description}
        primaryAction={primaryAction}
        onPrimaryAction={onPrimaryAction}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`mb-8 rounded-xl border border-neutral-200 bg-white p-4 ${cardClassName}`.trim()}>
          {children}
        </div>
      </div>
    </div>
  );
};

TablePageLayout.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  primaryAction: PropTypes.string,
  onPrimaryAction: PropTypes.func,
  children: PropTypes.node.isRequired,
  cardClassName: PropTypes.string
};

export default TablePageLayout;
